import { z } from "zod";
import { apiBuilder } from "@zodios/core";

const dspTargetSchema = z.object({
  id: z.number(),
  external_details: z.unknown().nullable(),
  created_on: z.string(),
  updated_on: z.string(),
  advertiser_id: z.string(),
  negative: z.boolean(),
  ad_product: z.string(),
  state: z.string(),
  target_details: z.unknown().nullable(),
  ad_group_id: z.string(),
  metadata: z.unknown().nullable(),
  org: z.number(),
  line_item: z.number(),
});

const dspTargetListResponseSchema = z.object({
  count: z.number(),
  next: z.string().nullable(),
  previous: z.string().nullable(),
  results: z.array(dspTargetSchema),
});

export const dspTargetApiDefinitions = apiBuilder({
  method: "get",
  path: "/dsp/target/",
  alias: "dspTargetList",
  description: "List DSP targets for a line item",
  parameters: [
    { name: "line_item", type: "Query", schema: z.string() },
    { name: "marketplace", type: "Query", schema: z.string() },
    { name: "limit", type: "Query", schema: z.number().optional() },
  ],
  response: dspTargetListResponseSchema,
}).build();
